module.exports = __webpack_public_path__ + "img/bronze.f273eee4.svg";